import mitt from 'mitt'

export const AppEventBus = mitt()

export const AppEventBusType = {
    INFORM: 'INFORM',
    CLOSE_INFORM: 'CLOSE_INFORM',
    TOAST: 'TOAST',
    CONFIRM: 'CONFIRM',
    EDIT_TEXT: 'EDIT_TEXT',
    SELECT_FILE: 'SELECT_FILE',
    // just for this project
    ZOOM: 'ZOOM',
    ZOOM_IN: 'ZOOM_IN',
    ZOOM_OUT: 'ZOOM_OUT',
    ACTIVE_STEP_CODE: 'ACTIVE_STEP_CODE',
    SCROLL_TO_ACTIVE_NODE: 'SCROLL_TO_ACTIVE_NODE',
    OPEN_SETTING: 'OPEN_SETTING',
    OPEN_SCENARIO_EDITOR: 'OPEN_SCENARIO_EDITOR',
    OPEN_SCENARIO_ADVANCE_SEARCH: 'OPEN_SCENARIO_ADVANCE_SEARCH',
    OPEN_STEP_EDITOR: 'OPEN_STEP_EDITOR',
    OPEN_STEP_SELECTOR: 'OPEN_STEP_SELECTOR',
    OPEN_VARIABLE_EDITOR: 'OPEN_VARIABLE_EDITOR',
    OPEN_VARIABLE_SELECTOR: 'OPEN_VARIABLE_SELECTOR',
    OPEN_CARD_DIALOG: 'OPEN_CARD_DIALOG',
    OPEN_BUTTON_SELECTOR: 'OPEN_BUTTON_SELECTOR',
    OPEN_BUTTON_EDITOR: 'OPEN_BUTTON_EDITOR',
    OPEN_CARD_HELP: 'OPEN_CARD_HELP',
    VIEW_INSPECT: 'VIEW_INSPECT',
    OPEN_BOT_EDITOR: 'OPEN_BOT_EDITOR',
    // knowledge base
    OPEN_KB_RELATION_CREATOR: 'OPEN_KB_RELATION_CREATOR',
    OPEN_KB_HYPEREDGE_EDITOR: 'OPEN_KB_HYPEREDGE_EDITOR',
    OPEN_KB_NODE_CREATOR: 'OPEN_KB_NODE_CREATOR',
    OPEN_KB_QUERY_HISTORY: 'OPEN_KB_QUERY_HISTORY',
    OPEN_BUILT_IN_FUNCTION: 'OPEN_BUILT_IN_FUNCTION'
}
